const fallback = {
  getItem: () => {},
  setItem: () => {}
}

function getLocalStorage() {
  try {
    return window.localStorage || fallback
  } catch (error) {
    return fallback
  }
}

const localStorage = getLocalStorage()

export default localStorage
